import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { GroupRoleApis } from 'apis/GroupRoleApis';
import { PlantApi } from 'apis/PlantApis';
import { FormFilter, InputForm, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectParams,
} from 'components/Select/LazySelectForm';
import { useUser } from 'contexts/UserProvider';
import Content from 'layouts/Content';
import { useEffect, useState } from 'react';
import { groupRewardOptions } from 'utils/constants/constant';

interface IProps {
  isOpen: boolean;
  defaultFilter: any;
  onCancel: () => void;
  onFinish: (values: any) => void;
  optionsBranch: DefaultOptionType[];
}
const spanCol = 8;
const FilterRewardCalculation = (props: IProps) => {
  const { isOpen, defaultFilter, onCancel, onFinish } = props;
  const { user } = useUser();
  const [form] = useForm();
  const [toDate, setToDate] = useState<any>(defaultFilter?.toDate);
  const [fromDate, setFromDate] = useState<any>(defaultFilter?.fromDate);
  // const [optionsEmployee, setOptionsEmployee] = useState<DefaultOptionType[]>(
  //   [],
  // );
  // const [optionsGroup, setOptionsGroup] = useState<any>({});
  const [plants, setPlants] = useState<DefaultOptionType[]>([]);
  const [optionsPosition, setOptionsPosition] = useState<any>({});

  const { mutate: getAllPlant, isPending: getAllPlantLoading } = useMutation({
    mutationFn: () => PlantApi.getAllPlantFilterHO(),
    onSuccess: (data: any) => {
      const items = data.data?.getPlant?.items || [];

      if (!items?.length) return setPlants([]);

      const plants = items.map((item: any) => ({
        label: item.id,
        value: item.id,
      }));

      setPlants(plants);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationPosition = useMutation({
    mutationFn: GroupRoleApis.getComboboxJobTitle,
    onSuccess: (res) => {
      const data = res?.data?.getJobTitle?.items || [];

      if (data.length === 0) return;

      setOptionsPosition({
        items: data.map((item: any) => ({
          label: item.jobName,
          value: item.id,
        })),
        pageInfo: res.data?.getJobTitle.pageInfo,
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  // const mutationGroup = useMutation({
  //   mutationFn: GroupRoleApis.getComboboxGroup,
  //   onSuccess: (res) => {
  //     const data = res?.data?.getCode?.items || [];

  //     if (data.length === 0) return;

  //     setOptionsGroup({
  //       items: data.map((item: any) => ({
  //         label: item.name,
  //         value: item.id,
  //       })),
  //       pageInfo: res.data?.getCode.pageInfo,
  //     });
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });

  useEffect(() => {
    form.setFieldsValue(defaultFilter);
  }, [defaultFilter, form]);

  const handleCancel = () => {
    form.resetFields();
    form.setFieldsValue(defaultFilter);

    onCancel();
  };

  const handlePositionSelectScrollChange = (value: ILazySelectParams) => {
    mutationPosition.mutate({
      skip: 0,
      take: value.pageSize,
      jobName: value.value,
    });
  };

  // const handleGroupSelectScrollChange = (value: ILazySelectParams) => {
  //   mutationGroup.mutate({
  //     skip: 0,
  //     take: value.pageSize,
  //     groupId: value.value,
  //   });
  // };

  useEffect(() => {
    getAllPlant();
  }, [getAllPlant]);

  return (
    <Content isOpen={isOpen}>
      <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Từ tháng"
              name="fromDate"
              rules={[{ required: true, message: '' }]}
            >
              <DatePicker
                placeholder="Chọn tháng"
                picker="month"
                format={'MM/YYYY'}
                maxDate={fromDate}
                size="large"
                className="w-full"
                onChange={(date) => setToDate(date)}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Đến tháng"
              name="toDate"
              rules={[{ required: true, message: '' }]}
            >
              <DatePicker
                placeholder="Chọn tháng"
                picker="month"
                format={'MM/YYYY'}
                minDate={toDate}
                size="large"
                className="w-full"
                onChange={(date) => setFromDate(date)}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã nhân viên" name="userId">
              <InputForm
                // options={optionsEmployee}
                placeholder="Tìm mã nhân viên"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chi nhánh" name="plantId">
              <SelectForm
                loading={getAllPlantLoading}
                options={[
                  {
                    label: 'Tất cả chi nhánh',
                    value: 'all',
                  },
                  ...plants,
                ]}
                disabled={!(user?.isAdmin || user?.isHO)}
                placeholder="Chọn chi nhánh"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Nhóm" name="groupId">
              {/* <LazySelectForm
                customeSize={20}
                data={{
                  options: optionsGroup.items || [],
                  totalItems: optionsGroup.pageInfo?.totalItems || 0,
                }}
                loading={mutationGroup.isPending}
                placeholder="Chọn nhóm"
                onSelectScrollChange={handleGroupSelectScrollChange}
              /> */}
              <SelectForm
                options={groupRewardOptions}
                placeholder="Chọn nhóm"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chức vụ" name="jobTitleCode">
              <LazySelectForm
                customeSize={20}
                data={{
                  options: optionsPosition.items || [],
                  totalItems: optionsPosition.pageInfo?.totalItems || 0,
                }}
                loading={mutationPosition.isPending}
                placeholder="Chọn chức vụ"
                onSelectScrollChange={handlePositionSelectScrollChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterRewardCalculation;
